import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Signup.css';
import iconBack from '../../assets/images/icon-back.svg';

interface LocationState {
  snsType?: string;
  snsId?: string;
  email?: string;
  name?: string;
  phone?: string;
  carrier?: string;
  gender?: string;
}

const Age: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  const [age, setAge] = useState<string | null>(null);

  const ageGroups = ['10대', '20대', '30대', '40대', '50대', '60대', '70대 이상'];

  const handleNext = () => {
    if (age) {
      navigate('/signup/location', {
        state: {
          ...state,
          age
        }
      });
    }
  };

  const handleSkip = () => {
    navigate('/signup/location', { state });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="signup-container">
      <div className="signup-header">
        <button className="back-button" onClick={handleBack}>
          <img src={iconBack} alt="뒤로가기" />
        </button>
      </div>

      <div className="signup-content">
        <div className="signup-inner">
          <div className="signup-form">
            <div className="signup-title-section">
              <h1 className="signup-title">
                본인의 연령대를
                <br />
                선택해 주세요.
              </h1>
            </div>

            <div className="age-grid">
              {ageGroups.map((ageGroup) => (
                <button
                  key={ageGroup}
                  className={`age-btn ${age === ageGroup ? 'selected' : ''}`}
                  onClick={() => setAge(ageGroup)}
                >
                  {ageGroup}
                </button>
              ))}
            </div>
          </div>

          <div className="signup-footer">
            <div className="spacer"></div>
            <button
              className={`signup-btn ${age ? 'active' : ''}`}
              onClick={handleNext}
              disabled={!age}
            >
              다음
            </button>
            <button className="skip-btn" onClick={handleSkip}>
              건너뛰기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Age;
